export var tableHeaderContainer = {
  padding: '1em 0'
};